import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'

/**
 * 应用场景枚举
 */
export const APPLICATION_SCENE = {
  UNKNOWN: { value: 0, key: 'CargoMsg.Cargo_Unknown' },
  BUSINESS_SINGLE: { value: 1, key: 'CargoMsg.Cargo_BusinessSingleMode' },
  BUSINESS_BATCH: { value: 5, key: 'CargoMsg.Cargo_BusinessBatchMode' },
  BPM: { value: 2, key: 'CargoMsg.Cargo_BPM' },
  OCR: { value: 3, key: 'CargoMsg.Cargo_OCR' },
  API: { value: 4, key: 'CargoMsg.Cargo_APIApplication' }
}

/**
 * 业务类型枚举
 * 目前支持类型：海运出口、空运出口
 */
export const BUSINESS_TYPE = {
  UNKNOWN: { value: 0, key: 'CargoMsg.Cargo_Unknown' },
  SEA_EXPORT: { value: 1, key: 'CargoMsg.Cargo_OceanExport', lob: 'SE' },
  AIR_EXPORT: { value: 2, key: 'CargoMsg.Cargo_AirExport', lob: 'AE' }
}

/**
 * 表单状态枚举
 */
export const ENABLED = {
  UNKNOWN: { value: 0, key: 'CargoMsg.Cargo_Unknown' },
  DISABLED: { value: 1, key: 'CargoMsg.Cargo_Disabled' },
  ENABLED: { value: 2, key: 'CargoMsg.Cargo_Enabled' }
}

/**
 * 表单发布状态枚举
 */
export const PUBLISHED = {
  UNKNOWN: { value: 0, key: 'CargoMsg.Cargo_Unknown' },
  DRAFT: { value: 1, key: 'CargoMsg.Cargo_Draft' },
  PUBLISHED: { value: 2, key: 'CargoMsg.Cargo_Published' }
}

/**
 * 页面区域类型枚举
 */
export const PAGE_PART_TYPE = {
  UNKNOWN: { value: 0, key: 'CargoMsg.Cargo_Unknown' },
  BUSINESS_ELEMENTS: { value: 1, key: 'CargoMsg.Cargo_BusinessElements' },

  // 需求变化，不再使用
  CONSIGNEE_SHIPPER_AND_NOTIFY_INFO: { value: 2, key: 'CargoMsg.Cargo_ConsigneeShipperAndNotifyInfo' },

  ACCOUNTS_RECEIVABLE: { value: 3, key: 'CargoMsg.Cargo_AccountsReceivable' },
  ACCOUNTS_PAYABLE: { value: 4, key: 'CargoMsg.Cargo_AccountsPayable' },
  UPLOAD_FILE: { value: 5, key: 'CargoMsg.Cargo_UploadFile' },
  CSN_INFO_SE_BASIC: { value: 6, key: 'CargoMsg.Cargo_CSNInfo_BASIC' },
  CSN_INFO_SE_MBL: { value: 7, key: 'CargoMsg.Cargo_CSNInfo_MBL' },
  CSN_INFO_SE_HBL: { value: 8, key: 'CargoMsg.Cargo_CSNInfo_HBL' },
  CSN_INFO_SE_HBL2: { value: 9, key: 'CargoMsg.Cargo_CSNInfo_HBL2' },
  OPERATION_AREA: { value: 10, key: 'CargoMsg.Cargo_OperationArea' },
  CUSTOMS_INFO: { value: 11, key: 'SeaExport.CustomsDeclarationInfo' },
  CONTAINER_INFO: { value: 12, key: 'SeaExport.ContainerInfo' },
  AE_CARGO_INFO: { value: 13, key: 'CargoMsg.Cargo_CargoInfo' },
  CSN_INFO_AE_BASIC: { value: 14, key: 'CargoMsg.Cargo_CSNInfo_BASIC' }
}

/**
 * 使用组件容器+动态渲染方式的分块类型
 * 这部分组件类型相对少，但每个的用法差异很大，不太好提取公共逻辑
 * 其他特殊分块类型会直接在 aiCustomPageDataView.vue 中编写组件代码
 * 2025.06.26 更新
 * 考虑到分块组件的种类不会很多，但情况很杂。
 * 有的一个区域要渲染几个不同组件，且属性、事件、排版各异，最终决定不用动态组件渲染这种方式了。
 * 这个机制的代码部分，依然保留。
 */
export const COMPONENT_REGISTRY_PAGE_PART_TYPES = []

/**
 * 收发通分块类型
 */
export const CSN_INFO_PAGE_PART_TYPES = [
  PAGE_PART_TYPE.CSN_INFO_SE_BASIC,
  PAGE_PART_TYPE.CSN_INFO_SE_MBL,
  PAGE_PART_TYPE.CSN_INFO_SE_HBL,
  PAGE_PART_TYPE.CSN_INFO_SE_HBL2,
  PAGE_PART_TYPE.CSN_INFO_AE_BASIC
]

/**
 * 包含第二通知人的收发通分块类型
 */
export const CSN_INFO_ALSO_NOTIFY_PAGE_PART_TYPES = [
  PAGE_PART_TYPE.CSN_INFO_SE_BASIC,
  PAGE_PART_TYPE.CSN_INFO_SE_HBL,
  PAGE_PART_TYPE.CSN_INFO_SE_HBL2,
  PAGE_PART_TYPE.CSN_INFO_AE_BASIC
]

/**
 * 包含代理信息的收发通分块类型
 */
export const CSN_INFO_AGENT_PARTY_PAGE_PART_TYPES = [
  PAGE_PART_TYPE.CSN_INFO_SE_HBL,
  PAGE_PART_TYPE.CSN_INFO_SE_HBL2
]

/**
 * 页面区域最大数量
 */
export const MAX_PAGE_PARTS = 5

export const DEFAULT_PAGE_PART = (counter) => ({
  id: counter,
  uuid: null,
  name: `页面区域${counter}`,
  elements: [],
  blockType: PAGE_PART_TYPE.BUSINESS_ELEMENTS.value,
  languageList: [
    {
      language: 'zh_CN',
      name: `页面区域${counter}`,
      type: 7,
      relatedUuid: null,
      uuid: null
    },
    {
      language: 'en_US',
      name: `Page Area ${counter}`,
      type: 7,
      relatedUuid: null,
      uuid: null
    },
    {
      language: 'ja_JP',
      name: `ページエリア${counter}`,
      type: 7,
      relatedUuid: null,
      uuid: null
    },
    {
      language: 'ru_RU',
      name: `Область страницы ${counter}`,
      type: 7,
      relatedUuid: null,
      uuid: null
    }
  ],
  businessConfig: DEFAULT_BUSINESS_CONFIG(),
  csnConfig: DEFAULT_CSN_CONFIG(),
  uploadConfig: {
    items: []
  },
  containerConfig: DEFAULT_CONTAINER_CONFIG(),
  aeCargoInfoConfig: DEFAULT_AE_CARGO_INFO_CONFIG()
})

/**
 * 默认业务字段配置
 */
export const DEFAULT_BUSINESS_CONFIG = () => ({
  isReadonly: false
})

/**
 * 默认收发通配置
 */
export const DEFAULT_CSN_CONFIG = () => ({
  isReadonly: false,
  needConsignee: true,
  needShipper: true,
  needNotify: true,
  needAlsoNotify: true,
  needAgentParty: true
})

/**
 * 默认装箱信息配置
 */
export const DEFAULT_CONTAINER_CONFIG = () => ({
  isReadonly: false,
  showContainerCargoInfo: false,
  showMasterContainerModeIfMaster: true,
  showUpdatePortDataButton: false
})

/**
 * 默认空运货物信息配置
 */
export const DEFAULT_AE_CARGO_INFO_CONFIG = () => ({
  isReadonly: false,
  goodsInfoContract: true,
  goodsInfoBooking: true,
  goodsInfoActual: true,
  quantityStation: true,
  quantitySigning: true,
  goodsInfoDocument: true
})

export const DEFAULT_SHIPPER_INFO = () => ({
  shipperCode: '',
  shipperId: 0,
  shipperLine1: '',
  shipperLine2: '',
  shipperLine3: '',
  shipperLine4: '',
  shipperLine5: '',
  shipperLine6: '',
  shipperLine7: ''
})

export const DEFAULT_CONSIGNEE_INFO = () => ({
  consigneeCode: '',
  consigneeId: 0,
  consigneeLine1: '',
  consigneeLine2: '',
  consigneeLine3: '',
  consigneeLine4: '',
  consigneeLine5: '',
  consigneeLine6: '',
  consigneeLine7: ''
})

export const DEFAULT_NOTIFY_INFO = () => ({
  notifyCode: '',
  notifyId: 0,
  notifyLine1: '',
  notifyLine2: '',
  notifyLine3: '',
  notifyLine4: '',
  notifyLine5: '',
  notifyLine6: '',
  notifyLine7: ''
})

export const DEFAULT_ALSO_NOTIFY_INFO = () => ({
  alsoNotify: ''
})

export const DEFAULT_AGENT_PARTY_INFO = () => ({
  agentCode: '',
  agentPartyLine1: '',
  agentPartyLine2: '',
  agentPartyLine3: '',
  agentPartyLine4: '',
  agentPartyLine5: '',
  agentPartyLine6: '',
  agentPartyLine7: ''
})

export const EXCLUDE_ELEMENTS = {
  [UICustomConstants.SEA_BOOKING_BASIC]: new Set([
    'shipper',
    'consignee',
    'notify',
    'alsoNotify'
  ]),
  [UICustomConstants.SEA_BOOKING_MBL]: new Set([
    'shipper',
    'consignee',
    'notify'
  ]),
  [UICustomConstants.SEA_BOOKING_HBL]: new Set([
    'shipper',
    'consignee',
    'notify',
    'alsoNotify',
    'agentParty'
  ]),
  [UICustomConstants.SEA_BOOKING_VIRTUAL_HBL]: new Set([
    'shipper',
    'consignee',
    'notify',
    'alsoNotify',
    'agentParty'
  ]),
  [UICustomConstants.AIR_BOOKING_BASIC]: new Set([
    'goodsInfoContract', // 件毛体(委托)
    'goodsInfoBooking', // 件毛体(订舱)
    'goodsInfoActual', // 件毛体(前置仓（实际）)
    'quantityStation', // 货站
    'quantitySigning', // 签单
    'goodsInfoDocument', // 件毛体(制单)
    'shipper', // 发货人
    'consignee', // 收货人
    'notify', // 通知人
    'alsoNotify' // 第二通知人
  ])
}

/**
 * 业务批量模式下需要完全隐藏的页签类型
 * 这些页签不会在批量模式的左侧树形结构中显示
 */
export const BUSINESS_BATCH_EXCLUDED_PAGE_TYPES = new Set([
  UICustomConstants.SEA_BOOKING_VIRTUAL_HBL // 23 - 海运订舱-形式分单页签
])

/**
 * 业务批量模式下的字段级别过滤配置
 *
 * 重要说明：
 * 批量模式会自动继承单笔模式的所有字段排除规则（EXCLUDE_ELEMENTS），
 * 然后在此基础上应用下面配置的额外排除规则。
 * 这确保了批量模式的字段限制比单笔模式更严格，符合业务逻辑。
 *
 * 字段排除优先级：
 * 1. 单笔模式排除规则（EXCLUDE_ELEMENTS）- 自动继承
 * 2. 批量模式额外排除规则（本配置）- 在继承基础上进一步限制
 *
 * 使用说明：
 * - 要完全隐藏某个页签：在 BUSINESS_BATCH_EXCLUDED_PAGE_TYPES 中添加页签类型
 * - 要在批量模式下额外排除某些字段：在下面配置中添加字段名
 *
 * 配置示例：
 * [UICustomConstants.SEA_BOOKING_BASIC]: new Set(['remarks', 'specialInstructions']),
 * [UICustomConstants.SEA_BOOKING_MBL]: new Set(['customsRemarks']),
 * [UICustomConstants.SEA_BOOKING_HBL]: new Set(['customerReference'])
 */
export const BUSINESS_BATCH_EXCLUDE_ELEMENTS = {
  // 在这里添加批量模式需要额外排除的字段
  // 注意：单笔模式已排除的字段会自动继承，无需重复配置
  //
  // 示例：在批量模式下额外排除基本页签的某些字段
  // [UICustomConstants.SEA_BOOKING_BASIC]: new Set(['complexField1', 'complexField2']),
  //
  // 示例：在批量模式下额外排除MBL页签的某些字段
  // [UICustomConstants.SEA_BOOKING_MBL]: new Set(['batchUnsuitableField']),

  /*
   * 继承机制说明：
   *
   * 假设单笔模式(EXCLUDE_ELEMENTS)已配置：
   * [UICustomConstants.SEA_BOOKING_BASIC]: ['shipper', 'consignee']
   *
   * 如果批量模式配置：
   * [UICustomConstants.SEA_BOOKING_BASIC]: ['remarks']
   *
   * 则批量模式实际排除字段为：['shipper', 'consignee', 'remarks']
   * 确保批量模式比单笔模式更严格
   */
}

export const READONLY_ELEMENTS = {
  [UICustomConstants.SEA_BOOKING_BASIC]: new Set([
    'jobNo'
  ]),
  [UICustomConstants.AIR_BOOKING_BASIC]: new Set([
    'jobNo'
  ])
}

// 用于大校验、大保存接口的传入job对象名称
export const JOB_LIST_NAMES = {
  SE: 'seJobList',
  SI: 'siJobList',
  AE: 'aeJobList',
  AI: 'aiJobList',
  RE: 'reJobList',
  RI: 'riJobList',
  IE: 'ieJobList'
}

// 跳过比较的job字段
export const SKIP_JOB_FIELDS = [
  // 业务子表字段
  'cargoDoc',
  'chargeFieldVO',
  'charges',
  'containerUsages',
  'containers',
  'seaCargoDocs',
  'seaEQ',
  'trackingInfo',
  'unitLoadDevices',
  'unitLoadDeviceUsages',
  'airCargoDocs',
  'airUld'
]

// 需要比较的job和子表对象
export const COMPARE_JOB_FIELDS = [
  'seaCargoDocs'
]

// job表中的报关字段
export const CUSTOMS_INFO_JOB_FIELDS = [
  'vatAmount', // 增值税金额
  'taxRemarks', // 税款备注
  'customsBroker', // 报关行
  'advancePayment', // 是否垫付关税
  'customsDutyAmount', // 关税金额
  'paymentTime', // 缴税时间
  'customsRemarks' // 备注
]
